import AddIcon from '@material-ui/icons/Add';
import React, { useCallback, useContext } from 'react';

import Button from 'Common/Button';

import { EmergencyContactContext } from '../../emergency-contacts.context';
import EmergencyContactForm from '../Form';

export default function Add() {
  const { setNewDialogOpened, newDialogOpened, reload } = useContext(EmergencyContactContext);

  const closeDialog = useCallback(
    success => {
      setNewDialogOpened(false);

      if (success) {
        reload();
      }
    },
    [reload, setNewDialogOpened]
  );

  const onClick = () => {
    setNewDialogOpened(true);
  };
  return (
    <>
      <header className="text-right mr-1">
        <Button startIcon={<AddIcon />} color="primary" onClick={onClick} className="ml-1">
          Yeni Kişi Ekle
        </Button>
      </header>
      <EmergencyContactForm onClose={closeDialog} data={null} open={newDialogOpened} />
    </>
  );
}
